import { render, staticRenderFns } from "./LeadBuyingOffers.vue?vue&type=template&id=70c2b4bb&scoped=true&"
import script from "./LeadBuyingOffers.vue?vue&type=script&lang=js&"
export * from "./LeadBuyingOffers.vue?vue&type=script&lang=js&"
import style0 from "./LeadBuyingOffers.vue?vue&type=style&index=0&id=70c2b4bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c2b4bb",
  null
  
)

export default component.exports